export default __webpack_public_path__ + "static/media/howItWorksHire3.050a92f9.png";